import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ParaApiRootService } from './para-api-root.service';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ParaRosterService {
	constructor(private readonly http: HttpClient, private readonly paraApi: ParaApiRootService) {}

	/** GET {@code /para/progress/students/nodeId/:id}. */
	getStudents$(nodeId: number, assessmentId?: string | null): Observable<any> {
		let params = new HttpParams();
		if (assessmentId) {
			params = params.set('assessmentId', assessmentId);
		}
		return this.http.get<any>(this.paraApi.progressUrl(`students/nodeId/${nodeId}`), { params });
	}

	/** GET {@code /para/roster/studentsPerChallenge/nodeId/:id}. */
	getStudentsPerChallenge$(nodeId: number): Observable<any> {
		return this.http.get<any>(this.paraApi.rosterUrl(`studentsPerChallenge/nodeId/${nodeId}`));
	}
}

